<script setup lang="ts">
import { computed, defineAsyncComponent, type Component } from 'vue';
import { useRoute } from 'vue-router';
import { useCommissioningDeviceStore } from '@/modules/commissioning/stores/commissioningDeviceStore';
import { useDeviceSpecificationStore } from '@/modules/commissioning/stores/deviceSpecificationStore';
import { getErrorComponentPath } from '@/modules/commissioning/utils/error-resolver';

// Pre-load all error page components using Vite's glob import
const errorPages = import.meta.glob('./**/*.vue', { eager: false });

const route = useRoute();
const deviceStore = useCommissioningDeviceStore();
const deviceSpecificationStore = useDeviceSpecificationStore();
const serialNumber = deviceStore.serialNumber;
const countryCode = deviceSpecificationStore.solshareSite?.country;
const errorType = String(route.params.errorType || '');

const errorComponent = computed(() => {
  return defineAsyncComponent(() => {
    const componentPath = getErrorComponentPath(serialNumber, errorType, countryCode);
    console.log(serialNumber, errorType, countryCode, componentPath);

    const componentLoader = errorPages[componentPath];

    if (componentLoader) {
      return componentLoader() as Promise<{ default: Component }>;
    }

    // Fallback to default error screen
    return (
      (errorPages[getErrorComponentPath()]?.() as Promise<{ default: Component }>) ||
      Promise.resolve({ default: null })
    );
  });
});
</script>

<template>
  <component :is="errorComponent"></component>
</template>
